// extracted by mini-css-extract-plugin
module.exports = {"panel":"GetInTouch_panel__1h-Us","panel-inner":"GetInTouch_panel-inner__tPzAM","title":"GetInTouch_title__1CBbt","line":"GetInTouch_line__3LHC6","arrow":"GetInTouch_arrow__1eJgr"};